import styled from 'styled-components'
import { DropzoneV2Unstyled } from './unstyled'

export const DropzoneV2 = styled(DropzoneV2Unstyled)`
  .file-preview {
    width: 100px;
    height: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }
  .fileName {
    width: 325px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dropzone-preview {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: url(${props => (props.input || {}).value}) no-repeat center;
    background-size: cover;
  }

  & > label:nth-child(1) {
    text-align: left;
    color: ${props => props.theme.colors.secondary};
    font-size: ${props => props.theme.fontSizes.form.label};
    font-family: ${props => props.theme.fonts.robotoRegular};
    margin: 0 0 10px 0;
    display: ${props => (props.mainLabel ? 'block' : 'none')};
  }

  & > div:nth-child(2) {
    position: relative;
    width: ${props => (props.isReport ? '100%' : '100px')};
    height: 100px;

    .dropzone {
      position: absolute;
      left: 0;
      right: 0;
      top: 20%;
      width: 100%;
      height: 60%;
      border: 1px dashed #798498;
      border-radius: 3px;
    }

    .dropzoneActive {
      border: 1px solid ${props => props.theme.colors.primary};
    }

    & > div > svg {
      position: absolute;
      left: 0;
      right: 0;
      top: 30px;
      margin: auto;
      fill: ${props => props.theme.colors.regentGray};
    }

    & > .dropzoneActive ~ svg {
      fill: ${props => props.theme.colors.primary};
      pointer-events: none;
    }

    & > div:nth-child(2) > div {
      text-align: center;
      position: absolute;
      bottom: 27px;
      width: 100%;
      color: ${props => props.theme.colors.regentGray};
      font-family: ${props => props.theme.fonts.robotoRegular};
      font-size: ${props => props.theme.fontSizes.dropZone.dropZoneLabel};
      pointer-events: none;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 5px;
    }

    & > div:nth-child(2) {
      .dropzone-text {
        bottom: 40px;
        color: '#011533';
      }

      .dropzone-text-active {
        bottom: 35px;
        color: '#011533';
        display: flex;
        justify-content: center;

        & > span:first-of-type {
          margin-left: 10px;
          margin-right: 20px;
        }

        & > span:not(:first-of-type) {
          cursor: pointer;
        }
      }
    }

    & > .dropzoneActive ~ div:nth-child(3) {
      color: ${props => props.theme.colors.primary};
    }
  }
`
